import jsPDF from 'jspdf';
import { PdfHeaderData } from '@/types/pdf';

export function renderPdfHeader(
  doc: jsPDF,
  data: PdfHeaderData,
  margins: { top: number; left: number; right: number }
): number {
  let currentY = margins.top;

  // Título principal
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(data.empresa, margins.left, currentY);
  currentY += 10;

  // Linha separadora
  const pageWidth = doc.internal.pageSize.getWidth();
  doc.setDrawColor(0, 0, 0);
  doc.line(margins.left, currentY, pageWidth - margins.right, currentY);
  currentY += 8;

  // Informações do documento
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text(`Receita: ${data.titulo}`, margins.left, currentY);
  currentY += 8;

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');

  if (data.produzidaPor) {
    doc.text(`Produzida por: ${data.produzidaPor}`, margins.left, currentY);
    currentY += 5;
  }

  doc.text(`Impressa por: ${data.impressaPor}`, margins.left, currentY);
  currentY += 5;

  doc.text(`Data da impressão: ${data.dataImpressao}`, margins.left, currentY);
  currentY += 10;

  // Linha separadora final
  doc.setDrawColor(200, 200, 200);
  doc.line(margins.left, currentY, pageWidth - margins.right, currentY);
  currentY += 5;

  return currentY;
}
